<template>
  <div class="vcenter" v-if="show_action">
    <v-icon
      :small="size == 'small'"
      :large="size == 'large'"
      :color="color"
      @click="handle_evidence"
    >
      mdi-open-in-new
    </v-icon>
    <MobileQUnitView
      v-if="unit"
      ref="qunit_view"
      :key="'qunit_view' + unit.instance_id"
      :unit="new_unit"
      :columns="unit.columns"
      :title="$vuetify.lang.translator('actions.view_qunit.data') + ' ' + (unit.readable_type? unit.readable_type : unit.business_process_name)"
      actions
      navigate
      :tabs="false"
      inline
    />
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import QUnit from '@/qunit/QUnit';
  export default {
    name: "QunitView",
    
    components: {
      MobileQUnitView: () => import('@/components/explorer/MobileQUnitView'),
    },

    props: {
      size: {default: 'small'},
      unit: {required: true},
      color: {},
    },

    data: () => ({
      new_unit: null,
    }),

    computed: {
      ...mapState(['bpmap',]),

      bps_data_inline() {
        return JSON.parse(JSON.stringify(this.bpmap._bps[this.unit.business_process])).inline_boxes.filter(it => it.type == 'inline-box-data');
      },

      show_action() {
        return this.unit;
      },
    },

    methods: {
      check_inlines() {
        if (this.unit && !this.new_unit) {
          this.new_unit = new QUnit({...this.unit,...({'inline_boxes': this.bps_data_inline})})
        }
      },
      handle_evidence() {
        this.check_inlines();
        this.$refs['qunit_view'].open();
        this.$emit('clicked');
      }
    },
  };
</script>